import VerificationEmail from './VerificationEmail'

export default VerificationEmail
